import React from 'react';
import { Button, Input } from 'components';
import { ClientHomeService } from 'services';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals } from 'utils';
import { CloseIcon } from 'assets/icons';
import { StarImage } from 'assets/img';

interface Props extends RootState {
	onClose: any;
}

class ModalReferral extends React.Component<Props> {

	state = {
		emails: [],
		form: {
			email: ''
		},
		result: null
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ClientHomeService.client.checkQuotes({
			user_id: this.props.user?.id
		});
		this.setState({
			result: res.result
		});	
	}

	submit = async () => {
		if (this.state.emails.length == 0) {
			Globals.showError("Debe ingresar al menos un correo");
			return;
		}
		await ClientHomeService.client.sendEmails({
			emails: JSON.stringify(this.state.emails),
			user_id: this.props.user?.id
		});
		this.props.onClose();
		Globals.showSuccess("Se han enviado los enlaces correctamente");
	}

	addItem = (item: any) => {
		let emails: any = [...this.state.emails];
		if (Globals.validateEmail(item)) {
			if (emails.indexOf(item) == -1) {
				emails.push(item);
				this.setState({
					emails,
					form: {
						email: ''
					}
				});
			}
			else {
				this.setState({
					form: {
						email: ''
					}
				});
			}
		}
		else {
			Globals.showError("El correo electrónico no es válido");
		}
	}

	deleteItem = (item: any) => {
		let emails: any = [...this.state.emails];
		this.setState({
			emails: emails.filter((i: any) => i != item)
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-send-referral" className="text-center">
				{
					this.state.result === true && (
						<>
							<p className="subtitle">Conecta a tus amigas(os) y obtén una Limpieza básica gratis</p>
							{
								this.state.emails.map((item: any) => {
									return (
										<div className="item-tag">
											<p>{ item }</p>
											<img src={ CloseIcon } onClick={ () => this.deleteItem(item) } />
										</div>
									)
								})
							}
							<Input
								color="white"
								value={ this.state.form.email }
								name="email"
								onChange={ this.change }
								onKeyPress={ (e: any) => {
									if (e.nativeEvent.key == "Enter") {
								        this.addItem(this.state.form.email);
								    }
								} } />
							<p className="note">Presiona "ENTER" para agregar un correo.</p>
							<Button className="btn-send" onClick={ (e: any) => this.submit() }>
								Enviar Conectada(o)
							</Button>
						</>
					)
				}
				{
					this.state.result === false && (
						<>
							<div className="no-services">
								<img src={ StarImage } />
								<p>Para conectar a una amiga o amigo, y obtener una Limpieza básica gratis, debes completar al menos uno de nuestros servicios.</p>
							</div>
						</>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalReferral);